import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

export default function SignComplete() {
  return (
    <div className="mx-auto max-w-md p-6 text-center">
      <CheckCircleIcon className="mx-auto h-14 w-14 text-emerald-500" />
      <h1 className="mt-3 text-2xl font-semibold">Signature submitted</h1>
      <p className="mt-2 text-slate-600">
        Ngā mihi. You'll receive the fully signed PDF by email once every
        signer has finished.
      </p>
    </div>
  );
}
